import { pipe, chain, isNil, reject } from 'ramda';

export const filterCommandsByItemRef = (itemRefs, printCommands) =>
  pipe(
    chain((itemRef) => {
      const command = printCommands.find((item) => item.itemRef === itemRef);
      if (command) {
        return command.printCommand;
      }

      return null;
    }),
    reject(isNil)
  )(itemRefs);
